import { Component, OnInit } from '@angular/core';
import {SignInComponent} from "@app/channels/auth/login/partials/sign-in/sign-in.component";
import {ScreenManagerService} from "@mpt-fo/common/core/services/screen-manager.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";

@Component({
  selector: 'app-mobile-sign-in',
  templateUrl: './mobile-sign-in.component.html',
  styleUrls: ['./mobile-sign-in.component.scss']
})
export class MobileSignInComponent extends SignInComponent implements OnInit {

  constructor(screenManager: ScreenManagerService, profileService: ProfileSetupService) {
	  super(screenManager, profileService);
  }

  ngOnInit(): void {
  }

}
